export enum AcceptedCountriesLabels {
  GREAT_BRITAIN = 'United Kingdom',
  IRELAND = 'Éire',
  ARMENIA = 'Hayastan',
  AUSTRIA = 'Österreich',
  BOSNIA_AND_HERZEGOVINA = 'Bosna i Hercegovina',
  CROATIA = 'Hrvatska',
  FINLAND = 'Suomi',
  HUNGARY = 'Magyarország',
  KOSOVO = 'Kosova',
  MONTENEGRO = 'Crna Gora',
  NETHERLANDS = 'Netherlands',
  NEW_ZEALAND = 'New Zealand',
  NORWAY = 'Norge',
  SERBIA = 'Srbija',
  SLOVAKIA = 'Slovensko',
  SLOVENIA = 'Slovenija',
  SWITZERLAND = 'Confoederatio Helvetica',
  GEORGIA = 'Sakartvelo',
  GERMANY = 'Deutschland',
  KENYA = 'Kenya',
  UNITED_ARAB_EMIRATES = 'UAE',
  CANADA = 'Canada',
  BRAZIL = 'Brazil',
  INDIA = 'India',
  MEXICO = 'Mexico',
  COLOMBIA = 'Colombia',
  CHILE = 'Chile',
  PERU = 'Peru',
  ARGENTINA = 'Argentina',
  ECUADOR = 'Ecuador',
  EL_SALVADOR = 'El Salvador',
  PARAGUAY = 'Paraguay',
  URUGUAY = 'Uruguay',
  ISLE_OF_MAN = 'Isle of Man',
}

export enum AcceptedCountries {
  GREAT_BRITAIN = 'GB',
  IRELAND = 'IE',
  ARMENIA = 'AM',
  AUSTRIA = 'AT',
  BOSNIA_AND_HERZEGOVINA = 'BA',
  CROATIA = 'HR',
  FINLAND = 'FI',
  HUNGARY = 'HU',
  KOSOVO = 'XK',
  MONTENEGRO = 'ME',
  NEW_ZEALAND = 'NZ',
  NORWAY = 'NO',
  SERBIA = 'RS',
  SLOVAKIA = 'SK',
  SLOVENIA = 'SI',
  SWITZERLAND = 'CH',
  GEORGIA = 'GE',
  KENYA = 'KE',
  UNITED_ARAB_EMIRATES = 'AE',
  CANADA = 'CA',
  BRAZIL = 'BR',
  INDIA = 'IN',
  MEXICO = 'MX',
  COLOMBIA = 'CO',
  CHILE = 'CL',
  PERU = 'PE',
  ARGENTINA = 'AR',
  ECUADOR = 'EC',
  EL_SALVADOR = 'SV',
  PARAGUAY = 'PY',
  URUGUAY = 'UY',
  ISLE_OF_MAN = 'IM',
}

export enum AvailableLanguage {
  ENGLISH = 'en',
  GERMAN = 'de',
  SPANISH = 'es',
  FRANCAIS = 'fr',
  HINDI = 'hi',
  MAGYAR = 'hu',
  PORTUGUESE_BRAZIL = 'pt-BR',
  FINNISH = 'fi',
}

export enum LiveMatchTrackerLanguage {
  BRAZILIAN = 'br',
}

export enum AvailableLanguageLabel {
  ENGLISH = 'English',
  GERMAN = 'Deutsch',
  FINNISH = 'Suomi',
  FRANCAIS = 'Français',
  SPANISH = 'Español',
  HINDI = 'हिन्दी',
  PORTUGUESE_BRAZIL = 'Português do Brasil',
  MAGYAR = 'Magyar',
}

export enum CUSTOMER_SERVICE_TELEPHONE {
  KENYA = '+254 (0) 111 050 280',
}

export enum CUSTOMER_SERVICE_EMAIL {
  KENYA = 'supportke@betkwiff.com',
}

export enum PhoneNumberRegistrationBlockedCountry {
  MYANMAR = 'MM',
  CAMBODIA = 'KH',
  VIETNAM = 'VN',
  LAOS = 'LA',
  NORTH_KOREA = 'KP',
  IRAN = 'IR',
  CHINA = 'CN',
  SRI_LANKA = 'LK',
  SWEDEN = 'SE',
}
